<template>
	<div>
		<img class="logo" v-if="name.startsWith('http')" :src="name" />
		<h1 class="logo" v-else>{{ name }}</h1>
			<h2>{{ $t('connect.registration') }}</h2>
			<div>{{ $t('profile.name') }}</div>
			<b-input v-model="prenom"></b-input>
			<div>{{ $t('profile.family_name') }}</div>
			<b-input v-model="nom"></b-input>
			<div>{{ $t('profile.mail') }}</div>
			<b-input type="email" v-model="email">{{ $t('profile.mail') }}</b-input>
			<div>{{ $t('connect.password') }}</div>
			<b-input type="password" v-model="mot_de_passe">{{ $t('connect.password_requirement') }}</b-input>
			<div v-for="field in fields.filter(item => item.type ? true : false)" :key="field.libelle">
				<div v-if="field.type == 'list'">
					<div>{{field.libelle}}</div>
					<b-select v-model="field.result" :options="field.list"></b-select>
					<br />
				</div>
				<div v-else>
					<div>{{field.libelle}}</div>
					<b-input v-model="field.result"></b-input>
				</div>
			</div>
			<br />
			<div v-if="recaptcha_key">
				<b-button @click="recaptcha" variant="primary">{{ $t('ui.validate') }}</b-button>
			</div>
			<div v-else>
				<b-button @click="submit" variant="primary">{{ $t('ui.validate') }}</b-button>
			</div>
			<br />
		<div>
			<b-alert v-if="error" show>{{ errorMsg }}</b-alert>
		</div>
	</div>
</template>

<script>
	import register from "../services/register.js";
	import store from "../store";

	export default {
		name: "register",
		data() {
			return {
				prenom: "",
				nom: "",
				email: "",
				mot_de_passe: "",
				token: "",
				error: false,
				errorMsg: null,
				name: process.env.VUE_APP_NAME || this.$t('smartmydata'),
				fields: [],
				recaptcha_key: process.env.VUE_APP_RECAPTCHA
			};
		},
		props: {
			_token: {
				default: "",
			},
			login: false
		},
		methods: {
			async recaptcha() {
				  await this.$recaptchaLoaded();
				  const token = await this.$recaptcha('login');

				this.submit(token);
				
					
			},
			submit(recaptcha) {
				var self = this;

				this.error = false;

				if (!this.prenom || !this.nom || !this.email || !this.mot_de_passe)
				{
					this.error = true;
					this.errorMsg =
						this.$t('connect.completed_fiels');
					return;
				}

				if (this.token)
				{
					register
						.register(this.prenom, this.nom, this.email, this.mot_de_passe, this.token, this.fields)
						.then((res) => {

							this.$notify({
								group: "info",
								title: this.$t('connect.account_created'),
								type: "success",
							});

							if (self._token)
								this.$emit('register')
							else
								this.$router.push({ name: "login" });
						})
						.catch((err) => {
							this.error = true;
							this.errorMsg = err;
						});
				}
				else
				{
					register
						.register_client(this.prenom, this.nom, this.email, this.mot_de_passe, recaptcha)
						.then((res) => {

							this.$notify({
								group: "info",
								title: this.$t('connect.account_created'),
								type: "success",
							});

							if (self._token || self.login)
								this.$emit('register')
							else
								this.$router.push({ name: "login" });
						})
						.catch((err) => {
							this.error = true;
							this.errorMsg = err;
						});
				}
			},
		},
		async destroyed() {
			const recaptcha = this.$recaptchaInstance
			recaptcha.hideBadge()
		},
		async mounted()
		{
			const recaptcha = this.$recaptchaInstance
			recaptcha.showBadge()

			this.token = this._token || this.$route.params.token;

			if (this.token)
			{
				this.fields = await register.register_get(this.token);
				this.fields = this.fields.fields;
			}
			
			for (var i = 0; i < this.fields.length; i++)
			{
				if (!this.fields[i].result)
					this.fields[i].result = "";
			}
		}
	};
</script>

<style>
	.logo {
		text-align: center;
		margin-left: auto;
		margin-right: auto;
		max-width: 100%;
		max-height: 100%;
		display: block;
	}
</style>
